import { useFeatureFlags } from './useFeatureFlags';

/**
 * PostHog flag gating the Planned Mastery pilot (HR-3777). Pilot clinics are targeted by a
 * `clinicId` cohort in the PostHog dashboard, so the pilot roster changes without a deploy.
 */
export const PLANNED_MASTERY_ENABLED = 'planned_mastery_enabled';

/**
 * Whether the Planned Mastery pilot is enabled for the current user/clinic.
 *
 * Resolves to `false` until flags load and wherever PostHog is inert (Canada/Australia, and dev-US)
 * — the pilot is opt-in, so an unknown state must hide the feature rather than expose it.
 *
 * @returns {{ flagsReady: <boolean>, plannedMasteryEnabled: <boolean> }}
 */
// eslint-disable-next-line import/prefer-default-export
export function usePlannedMasteryFeature() {
  const { flagsReady, useFeatureEnabled } = useFeatureFlags();

  const plannedMasteryEnabled = useFeatureEnabled(PLANNED_MASTERY_ENABLED);

  return {
    flagsReady,
    plannedMasteryEnabled,
  };
}
